document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth < 990) return;

  const triggers = document.querySelectorAll(".dm-trigger");
  let closeTimer;

  triggers.forEach(trigger => {
    const details = trigger.closest("details");
    const panel = details.querySelector(".mega-menu__content");

    if (!panel) return;

    function openMenu() {
      clearTimeout(closeTimer);

      document.querySelectorAll("details[open]").forEach(d => {
        if (d !== details) d.removeAttribute("open");
      });

      details.setAttribute("open", "");
    }

    function closeMenu() {
      details.removeAttribute("open");
    }

    trigger.addEventListener("mouseenter", openMenu);

    trigger.addEventListener("mouseleave", () => {
      closeTimer = setTimeout(() => {
        if (!panel.matches(":hover")) closeMenu();
      }, 150);
    });

    panel.addEventListener("mouseenter", () => {
      clearTimeout(closeTimer);
    });

    panel.addEventListener("mouseleave", closeMenu);
  });
});
